<template>
  <div v-if="actions.length" class="widget-title-actions">
    <slot name="prepend"></slot>
    <!-- Directe knoppen (alleen als menuOnly = false) -->
    <v-btn
      v-for="(item, idx) in displayItems"
      :key="item.title + '-' + idx"
      :block="btnBlock"
      :variant="btn_variant"
      class="ui-btn"
      @click="handleItemClick(item, idx)"
      :class="{
        'ui-btn-accent-primary': idx === 0,
        'ui-btn-accent-secondary': idx !== 0,
      }"
      :loading="loadingIndex === idx"
    >
      <template v-if="item.icon" v-slot:prepend>
        <ui-icon :name="item.icon" :size="18" />
      </template>
      {{ replaceFieldFromDetailPage("title", item.title) }}
    </v-btn>

    <!-- Overflow / Alle items in menu -->
    <v-btn
      v-if="overflowItems.length"
      class="ui-btn ui-btn-icon ui-btn-accent-secondary"
      :block="btnBlock"
    >
      <ui-icon name="ellipsis-vertical" />
      <v-menu
        activator="parent"
        class="ui-menu kyano-menu"
        :width="160"
        location="bottom"
      >
        <v-list>
          <ui-list-item
            v-for="(item, idx) in overflowItems"
            :key="item.title + '-menu-' + idx"
            :title="replaceFieldFromDetailPage('title', item.title)"
            :icon="item.icon"
            @click="handleItemClick(item, idx + (menuOnly ? 0 : slice))"
          />
        </v-list>
      </v-menu>
    </v-btn>
  </div>
</template>

<script>
  import { useAppStore } from "@/stores/appStore";
  import actionsMixin from "@/mixins/actionsMixin";
  import wh from "@/helpers/widgetsHelpers.js";
  import { parseJsonField } from "@/util/parseJson";

  export default {
    mixins: [actionsMixin],
    props: {
      actions: { type: Array, default: () => [] },
      data: { type: Object, default: () => ({}) },
      slice: { type: Number, default: 2 }, // na hoeveel knoppen overflow start
      menuOnly: { type: Boolean, default: false }, // als true: geen losse knoppen, alles in menu
      btn_variant: { type: String, default: "flat" },
      btnBlock: { type: Boolean, default: false },
      collection_id: { type: Number }, // collection data voor context
    },
    data() {
      return {
        loading: false,
        loadingIndex: null,
      };
    },
    computed: {
      // kies de items die je direct als knoppen toont
      displayItems() {
        return this.menuOnly ? [] : this.actions.slice(0, this.slice);
      },
      // kies de items die in het menu terechtkomen
      overflowItems() {
        return this.menuOnly ? this.actions : this.actions.slice(this.slice);
      },
      appStore() {
        return useAppStore();
      },

      rawCollectionId() {
        const c = this.data?.collection?.collection;
        if (c) {
          // andere types
          return c;
        }
      },
    },
    methods: {
      replaceFieldFromDetailPage(type, template) {
        return wh.replaceFieldFromDetailPage(type, template);
      },

      replaceFieldToData(item, type) {
        return wh.replaceFieldToData(item, type, this.data);
      },

      async handleItemClick(item) {
        console.log("handleItemClick called with item:", item);

        /* 1. action & actionType direct uit het aangeklikte item  */
        const action = item.action || {}; // fallback leeg object
        const actionType = action.type;

        if (!actionType) {
          console.warn("action type not found on item");
          return; // stop hier – je weet niet wat je moet doen
        }

        /* 2. collectionId uit de action → action.collection.id  */
        const collectionId = action.collection?.id;
        // if (!collectionId) {
        //   console.warn("Geen collection_id beschikbaar voor actionItemClicked");
        //   this.$toast.error("Collectie onbekend.");
        //   return;
        // }

        /* 3. payload opbouwen  */
        const payload = {
          collection_id: collectionId,
          page_title: this.replaceFieldToData(item, "title"),
          // alle ruwe item-properties erbij
          ...item,
          action,
          widget: {
            ...this.data,
            collection: parseJsonField(this.data.collection),
          },
        };

        console.log("actionType:", actionType);
        console.log("payload   :", payload);

        try {
          await this.actionsTrigger(actionType, payload);
        } catch (err) {
          console.error("Error executing ItemClickAction:", err);
        }
      },

      //   async handleItemClick(item) {
      //     console.log("item", item);
      //     const collectionId = item.action.collection.id;
      //     if (!collectionId) {
      //       console.warn(
      //         "Geen collection_id beschikbaar voor actionItemClicked in actionbuttons"
      //       );
      //       this.$toast.error("Collectie onbekend.");
      //       return;
      //     }

      //     console.log("handleItemClick called with item:", item);

      //     const configs = this.data?.data?.item_click_actions || [];
      //     if (!configs.length) {
      //     }
      //     const config = configs[0];
      //     const actionType = config?.action?.type;
      //     // if (!actionType) return;

      //     const payload = {
      //       collection_id: collectionId,
      //       page_title: this.replaceFieldToData(item, "title"),
      //       ...item,
      //       action: config,
      //       widget: {
      //         ...this.data,
      //         collection: parseJsonField(this.data.collection),
      //       },
      //     };

      //     console.log("action delete called with payload:", payload);
      //     console.log("actionType:", actionType);

      //     try {
      //       await this.actionsTrigger(actionType, payload);
      //     } catch (err) {
      //       console.error("Error executing ItemClickAction:", err);
      //     }
      //   },
    },
  };
</script>

<style>
  .widget-title-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
</style>
